import React, { Component } from 'react'
import { BrowserRouter as Router,Route,Link } from 'react-router-dom';
import SeatSelect from './pages/seatSelect';
import Login from './pages/Login';
import About from './pages/about';
// import Guides from './pages/guides';
import Guide01 from './pages/guide01';
import Guide02 from './pages/guide02';
import Guide03 from './pages/guide03';
import Guide04 from './pages/guide04';
import Guide05 from './pages/guide05';
import ExamView from './pages/examView';
import ExamResult from './pages/examResult';
import './App.css';
import './css/font/font.css';
import './css/bootstrap/css/bootstrap.min.css';
import './css/common.css';

export default class App extends Component {

  state = {
      currentClass: false,
      seatNumbers: [...Array(150).keys()],
      pageTitles: ['좌석번호 선택', '응시자 로그인'],
      examTotalNumber: [...Array(88).keys()],
      guides: [
        {id: 'guide01', title: '유의사항', nextPath: 'guide02',},
        {id: 'guide02', title: '부정행위', prePath: 'guide01', nextPath: 'guide03',},
        {id: 'guide03', title: '비밀유지', prePath: 'guide02', nextPath: 'guide04',},
        {id: 'guide04', title: '시간표', prePath: 'guide03', nextPath: 'guide05',},
        {id: 'guide05', title: '교시대기', prePath: 'guide04'}
      ]
  };

  handleOpen = () => {
      const currentClass = this.state.currentClass;
      this.setState({currentClass: true});
      //console.log(currentClass);
  };

  handlClose = () => {
      const currentClass = this.state.currentClass;
      this.setState({currentClass: false});
      //console.log(currentClass);
  };

  render() {
    return (
      <>
        <Router>
          <Route path='/seatSelect' render={() => (
            <SeatSelect pageTitles={this.state.pageTitles[0]} seatNumbers={this.state.seatNumbers} />
          )} />
          <Route exact path='/' render={() => (
            <SeatSelect pageTitles={this.state.pageTitles[0]} seatNumbers={this.state.seatNumbers} />
          )} />
          <Route path='/about' component={About} />
          <Route path='/Login/:sit' component={Login} /> 
          {/* <Route path='/guides' component={Guides} /> */}
          <Route path='/guide01' render={() => (
            <Guide01 key={this.state.guides[0].key} guide={this.state.guides[0]}></Guide01>
          )} />
          <Route path='/guide02' render={() => (
            <Guide02 key={this.state.guides[1].key} guide={this.state.guides[1]}></Guide02>
          )} />
          <Route path='/guide03' render={() => (
            <Guide03 key={this.state.guides[2].key} guide={this.state.guides[2]}></Guide03>
          )} />
          <Route path='/guide04' render={() => (
            <Guide04 key={this.state.guides[3].key} guide={this.state.guides[3]}></Guide04>
          )} />
          <Route path='/guide05' render={() => (
            <Guide05 key={this.state.guides[4].key} guide={this.state.guides[4]}></Guide05>
          )} />
          <Route path='/examView' render={() => (
            <ExamView examTotalNumber={this.state.examTotalNumber} currentClass={this.state.currentClass} onOpen={this.handleOpen} onClose={this.handlClose} />
          )} />
          <Route path='/examResult' render={() => (
            <ExamResult examTotalNumber={this.state.examTotalNumber} currentClass={this.state.currentClass} onOpen={this.handleOpen} onClose={this.handlClose} />
          )} />
        </Router>
      </>
    )
  }
}
